import { AxiosResponse } from "axios";
import axiosInstance from "../../../interceptors/axiosInstance";
import { RowComprobanteLiquidacion } from "../models/headerComprobanteLiquidacion";
import { CalculoMontoInputDto } from "../models/calculoMontoModel";

const getResumenMutuo = async (mutuoId: number) => {
    const response: Promise<AxiosResponse> = axiosInstance.get(`siscred-api-mutuo/v1/mutuo/obtener-resumen-mutuo?mutuoId=${mutuoId}`);
    return response;
}

const getDatosTabla = async (mutuoId: number) => {
    const response: Promise<AxiosResponse> = axiosInstance.get(`siscred-api-mutuo/v1/mutuo/obtener-tablas-mutuo?mutuoId=${mutuoId}`);
    return response;
}

const getEstadoMutuo = async (mutuoId: number) => {
    const response: Promise<AxiosResponse> = axiosInstance.get(`siscred-api-mutuo/v1/mutuo/obtener-estado-mutuo?mutuoId=${mutuoId}`);
    return response;
}

const getFechaActivacion = async (mutuoId: number) => {
    const response: Promise<AxiosResponse> = axiosInstance.get(`siscred-api-mutuo/v1/mutuo/obtener-fecha-activacion-mutuo?mutuoId=${mutuoId}`);
    return response;
}

const getDetalleLiquidacion = async (mutuoId: number) => {
    const response: Promise<AxiosResponse> = axiosInstance.get(`siscred-api-cartera-total/v1/liquidacion/obtener-liquidacion?mutuoId=${mutuoId}`);
    return response;
}

const getTablaDetalleLiquidacion = async (mutuoId: number) => {
    const response: Promise<AxiosResponse> = axiosInstance.get(`siscred-api-cartera-total/v1/liquidacion/obtener-detalle-liquidacion?mutuoId=${mutuoId}`);
    return response;
}

const crearBeneficiarioLiquidacion = async (mutuoId: number, beneficiario: RowComprobanteLiquidacion) => {
    const response: Promise<AxiosResponse> = axiosInstance.post(`siscred-api-cartera-total/v1/liquidacion/agregar-beneficiario?mutuoId=${mutuoId}`, beneficiario);
    return response;
}

const actualizarBeneficiarioLiquidacion = async (mutuoId: number, beneficiario: RowComprobanteLiquidacion) => {
    const response: Promise<AxiosResponse> = axiosInstance.put(`siscred-api-cartera-total/v1/liquidacion/${mutuoId}/beneficiarios/${beneficiario.rut}`, beneficiario);
    return response;
}

const eliminarBeneficiarioLiquidacion = async (mutuoId: number, rut: string) => {
    const response: Promise<AxiosResponse> = axiosInstance.delete(`siscred-api-cartera-total/v1/liquidacion/${mutuoId}/beneficiarios/${rut}`);
    return response;
}

const calcularMontoAPagar = async (calculoRequest: CalculoMontoInputDto) => {
    const response: Promise<AxiosResponse> = axiosInstance.post(`siscred-api-cartera-total/v1/liquidacion/calcular-monto-pago`, calculoRequest);
    return response;
}

const liquidarMutuo = async (mutuoId: number, fechaLiquidacion: Date) => {
    const fecha = new Date(fechaLiquidacion);
    const dateString: string = fecha.toISOString().split('T')[0];

    const response: Promise<AxiosResponse> = axiosInstance.post(`siscred-api-cartera-total/v1/liquidacion/liquidar-mutuo`, {
        mutuoId,
        fecha: dateString
    });
    return response;
}

const desliquidarMutuo = async (mutuoId: number) => {
    const response: Promise<AxiosResponse> = axiosInstance.post(`siscred-api-cartera-total/v1/liquidacion/desliquidar-mutuo`, {
        mutuoId
    });
    return response;
}

export {
    getResumenMutuo,
    getDatosTabla,
    getEstadoMutuo,
    getDetalleLiquidacion,
    getTablaDetalleLiquidacion,
    getFechaActivacion,
    crearBeneficiarioLiquidacion,
    actualizarBeneficiarioLiquidacion,
    eliminarBeneficiarioLiquidacion,
    calcularMontoAPagar,
    liquidarMutuo,
    desliquidarMutuo
}